module.exports = __webpack_public_path__ + "1c23b8c9945e4fab0ad0631cacb0f20e.svg";